import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { StartInkindCard } from '@gik/ui';
import { CreateClickedLocation } from '@gik/create/hooks/useCreateAnalytics';

const blockName = 'start-inkind';

export default function StartInkind() {
  const bem = bemBlock(blockName);

  return (
    <section className={bem()}>
      <StartInkindCard trackingId={CreateClickedLocation.HOMEPAGE_HALF} />
    </section>
  );
}
